import React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector = () => {
    const { i18n } = useTranslation();
    const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setSelectedLanguage(lng);
    };

    return (
        <div className="language-selector">
            <select
                value={selectedLanguage}
                onChange={(e) => changeLanguage(e.target.value)}
                className="language-dropdown"
            >
                <option value="en">
                    English
                </option>
                <option value="ge">
                    ქართული
                </option>
                <option value="ru">
                    Русский
                </option>
                <option value="am">
                    Հայերեն
                </option>
            </select>
        </div>
    );
};

export default LanguageSelector;
